export const STEP = {
  CUSTOMER: 1,
  DELIVERY_HOURS: 2,
  ADD_CARD: 3,
  IMAGES: 4
};
